/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { ToastrService } from "ngx-toastr";
import { FormBuilder, Validators } from "@angular/forms";
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Inject,
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WhiteshopLoginComponent } from "src/app/features/auth-feature/whiteshop-login/whiteshop-login.component";
import { RegexService } from "src/app/services/shared/regex/regex.service";
import { SignInService } from "../authServices/signin.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { RegisterStoreComponent } from "../register-store/register-store.component";
import { icons } from "src/environments/config";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { setActualDimensions } from "../../liveshop/utils/helpers";

@Component({
  selector: "app-whiteshop-forgot-password",
  templateUrl: "./whiteshop-forgot-password.component.html",
  styleUrls: ["./whiteshop-forgot-password.component.scss"],
})
export class WhiteshopForgotPasswordComponent implements OnInit {
  windowHeight: number;
  windowWidth: number;
  public userForm = this.formBuilder.group({
    username: ["", [Validators.required]],
  });
  public otpForm = this.formBuilder.group({
    box1: [null, [Validators.required, Validators.maxLength(1)]],
    box2: [null, [Validators.required, Validators.maxLength(1)]],
    box3: [null, [Validators.required, Validators.maxLength(1)]],
    box4: [null, [Validators.required, Validators.maxLength(1)]],
    box5: [null, [Validators.required, Validators.maxLength(1)]],
    box6: [null, [Validators.required, Validators.maxLength(1)]],
  });
  public isOtp = false;
  public isPassword = false;
  public otp;
  public password;
  public confirmPassword;
  public message = "";
  public whiteShopIcon = icons.whiteShopIcon.icon;
  passwordType1 = "password";
  passwordVisibility1 = false;
  passwordType2 = "password";
  passwordVisibility2 = false;
  passwordImg1 = icons.whiteShopIcon.eyeSlash;
  passwordImg2 = icons.whiteShopIcon.eyeSlash;
  otpRegex = this.regexService.getOtpRegex();
  codeResent = "";
  public isWidget = false;
  public isCustomerView = false;
  isEmailOrMobileConditional = false;
  isPhoneMandatory = true;
  isEmailMandatory = true;

  @ViewChild("box1", { static: false }) box1: ElementRef;
  @ViewChild("box2", { static: false }) box2: ElementRef;
  @ViewChild("box3", { static: false }) box3: ElementRef;
  @ViewChild("box4", { static: false }) box4: ElementRef;
  @ViewChild("box5", { static: false }) box5: ElementRef;
  @ViewChild("box6", { static: false }) box6: ElementRef;
  @ViewChild("passwordOne", { static: false }) passwordOne: ElementRef;
  @ViewChild("passwordTwo", { static: false }) passwordTwo: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<WhiteshopForgotPasswordComponent>,
    public formBuilder: FormBuilder,
    public localStorageService: LocalStorageService,
    public regexService: RegexService,
    public signInService: SignInService,
    public toastrService: ToastrService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit(): void {
    this.isEmailOrMobileConditional =
      location.origin === "https://store.7aarkfashions.com" ||
      location.origin === "https://intercept-qa.valustore.in" ||
      location.origin === "http://localhost:4200";
    this.iconRegistry.addSvgIcon(
      "arrow_back",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrowBackBlack.svg"
      )
    );
    this.setDimensions();
    this.codeResent = "";
    let config = JSON.parse(
      localStorage.getItem("config")
        ? localStorage.getItem("config")
        : localStorage.getItem("companyConfig")
    );
    if (config?.whiteshop?.companyLogo) {
      this.whiteShopIcon = config.whiteshop.companyLogo;
    }
    if (config) {
      this.isPhoneMandatory = config.whiteshop.externalUser.isOTPAuthEnabled;
      this.isEmailMandatory = config.whiteshop.externalUser.isEmailAuthEnabled;
    }
    if (!this.isPhoneMandatory && !this.isEmailMandatory) {
      this.isPhoneMandatory = !this.isEmailOrMobileConditional;
      this.isEmailMandatory = this.isEmailOrMobileConditional;
    }
    this.isWidget = this.dialogData?.isWidget;
    this.isCustomerView = this.dialogData.isCustomerView;
    this.userForm.controls.username.patchValue(
      this.dialogData?.previousUserName ? this.dialogData.previousUserName : ""
    );
  }
  backToHome() {
    this.message = "";
    if (this.isPassword) {
      this.isOtp = true;
      this.isPassword = false;
    } else if (this.isOtp) {
      this.isOtp = false;
    } else {
      this.dialogRef.close();
    }
  }
  backPressEvent(index, event?) {
    const keyCode = event.keyCode;
    if (keyCode === 8) {
      const name = "box" + index;
      this.otpForm.controls[name].value
        ? this.focus(index, true)
        : this.focus(index - 1, true);
    } else if (keyCode === 37) {
      this.focus(index - 1);
    } else if (keyCode === 39) {
      this.focus(index + 1);
    } else {
      const name = "box" + index;
      this.otpForm.controls[name].patchValue(event.value);
    }
  }
  editOtpDigit(digit) {
    setTimeout(() => {
      digit.scrollLeft = digit.scrollWidth;
      digit.setSelectionRange(digit.value.length, digit.value.length);
    }, 1);
  }
  onKeyUpFunction(index) {
    const name = "box" + index;
    if (this.otpForm.controls[name].valid && index <= 6) {
      this.focus(index + 1);
    } else {
      this.otpForm.controls[name].reset();
    }
  }

  focus(index, backspace?) {
    switch (index) {
      case 1:
        this.box1.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box1.reset();
        }
        this.editOtpDigit(this.box1.nativeElement);
        break;
      case 2:
        this.box1.nativeElement.blur();
        this.box2.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box2.reset();
        }
        this.editOtpDigit(this.box2.nativeElement);
        break;
      case 3:
        this.box2.nativeElement.blur();
        this.box3.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box3.reset();
        }
        this.editOtpDigit(this.box3.nativeElement);
        break;
      case 4:
        this.box3.nativeElement.blur();
        this.box4.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box4.reset();
        }
        this.editOtpDigit(this.box4.nativeElement);
        break;
      case 5:
        this.box4.nativeElement.blur();
        this.box5.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box5.reset();
        }
        this.editOtpDigit(this.box5.nativeElement);
        break;
      case 6:
        this.box5.nativeElement.blur();
        this.box6.nativeElement.focus();
        if (backspace) {
          this.otpForm.controls.box6.reset();
        }
        this.editOtpDigit(this.box6.nativeElement);
        break;
      case 7:
        this.box6.nativeElement.blur();
      default:
        break;
    }
  }

  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const name = "box" + item;
      if (!this.otpForm.controls[name].valid) {
        this.focus(item);
        break;
      }
    }
  }
  onPasteOtp($event: ClipboardEvent) {
    let pastedText = $event.clipboardData.getData("text");
    pastedText = pastedText.replace(/ /g, "");
    const otpRegex = new RegExp(/^[0-9]{6}$/);
    $event.preventDefault();
    $event.stopPropagation();
    if (pastedText.length !== 6 || !otpRegex.test(pastedText)) {
      this.toastrService.error("The OTP is not in correct format", null, {
        timeOut: 2000,
      });
      return;
    }
    for (let a = 0; a < 6; a++) {
      const name = "box" + (a + 1);
      this.otpForm.controls[name].reset();
      this.otpForm.controls[name].patchValue(pastedText[a]);
    }
    this.box1.nativeElement.blur();
    this.box2.nativeElement.blur();
    this.box3.nativeElement.blur();
    this.box4.nativeElement.blur();
    this.box5.nativeElement.blur();
    this.box6.nativeElement.blur();
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }

  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }

  isDataValid() {
    const isPhone = this.regexService
      .getPhoneRegex()
      .test(this.userForm.controls.username.value);
    const isEmail = this.regexService
      .getEmailRegex()
      .test(this.userForm.controls.username.value);
    return this.userForm.controls.username.dirty &&
      this.isEmailOrMobileConditional &&
      (this.isCustomerView || this.isWidget)
      ? this.isPhoneMandatory && !this.isEmailMandatory
        ? isPhone
        : isEmail
      : isEmail || isPhone;
  }
  getOtp() {
    if (this.otpForm.valid) {
      this.otp =
        this.otpForm.controls.box1.value.toString() +
        this.otpForm.controls.box2.value.toString() +
        this.otpForm.controls.box3.value.toString() +
        this.otpForm.controls.box4.value.toString() +
        this.otpForm.controls.box5.value.toString() +
        this.otpForm.controls.box6.value.toString();
    } else {
      this.toastrService.error("Invalid OTP", null, { timeOut: 2000 });
    }
  }

  handleSubmit() {
    const type =
      !this.isOtp && !this.isPassword
        ? "username"
        : this.isOtp && !this.isPassword && this.otpForm.valid
        ? "otp"
        : this.isPassword
        ? "password"
        : "";
    if (type?.length) {
      this.submit(type);
    }
  }

  submit(type) {
    switch (type) {
      // when user enter username and requests for OTP
      case "username":
        const request = {
          changePassword: false,
          forgotPassword: null,
          newPassword: null,
          otpGenerated: false,
          otpVerified: false,
          username: this.userForm.value.username,
          verifyPassword: null,
        };
        if (
          this.regexService.getEmailRegex().test(this.userForm.value.username)
        ) {
          request["email"] = this.userForm.value.username;
        } else if (
          this.regexService.getPhoneRegex().test(this.userForm.value.username)
        ) {
          request["phone"] = this.userForm.value.username;
        }
        if (
          sessionStorage.getItem("currentBusinessUnit") &&
          sessionStorage.getItem("currentBusinessUnit") !== "undefined"
        ) {
          request["companyName"] = JSON.parse(
            sessionStorage.getItem("currentBusinessUnit")
          )?.company?.name;
        }
        this.otpForm.reset();
        this.otp = null;
        this.signInService.sendOTP(request).subscribe(
          (res) => {
            if (this.isOtp) {
              this.codeResent = " again ";
            }
            console.log(JSON.stringify(res));
            this.isOtp = true;
            setTimeout(() => {
              this.box1.nativeElement.focus();
            }, 1);
            this.message = res["message"];
          },
          (err) => {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
        break;

      // After user enters OTP and confirms his identity as valid user to update password
      case "otp":
        this.getOtp();
        if (!this.otp) {
          break;
        }
        this.message = "";
        const verifyForgotOtp = {
          changePassword: false,
          forgotPasswordOtp: this.otp,
          newPassword: null,
          otpGenerated: true,
          otpVerified: false,
          username: this.userForm.value.username,
          verifyPassword: null,
        };
        this.signInService.verifyOTP(verifyForgotOtp).subscribe(
          (res) => {
            console.log(JSON.stringify(res));
            if (res["verifiedOtp"]) {
              this.isPassword = true;
              setTimeout(() => {
                this.passwordOne.nativeElement.focus();
              }, 1);
            } else {
              this.toastrService.error("Invalid OTP", null, { timeOut: 2000 });
            }
          },
          (err) => {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
        break;

      // After OTP validates and user enter both password and confirm password
      case "password":
        const request1 = {
          changePassword: false,
          forgotPasswordOtp: this.otp,
          newPassword: this.password,
          otpGenerated: false,
          otpVerified: true,
          username: this.userForm.value.username,
          verifyPassword: this.confirmPassword,
        };
        this.signInService.changePassword(request1).subscribe(
          (res: any) => {
            if (res.status) {
              this.toastrService.success(
                "Password changed successfully",
                null,
                { timeOut: 2000 }
              );
              this.dialogRef.close();

              // After password is updating,user will navigated to login page

              if (!this.dialogData.consumer) {
                this.dialogService.openMatDialog(
                  WhiteshopLoginComponent,
                  null,
                  false,
                  false,
                  null,
                  true,
                  true
                );
              }
            } else {
              this.toastrService.error("Something went wrong", null, {
                timeOut: 2000,
              });
            }
          },
          (err) => {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
        break;
    }
  }

  // navigation to registration
  register() {
    this.dialogService.openMatDialog(
      RegisterStoreComponent,
      { type: "B2C" },
      true,
      null,
      null,
      null,
      true
    );
    this.dialogRef.close();
  }

  // to display password to user
  togglePasswordVisibility(type) {
    switch (type) {
      case "password":
        if (this.passwordVisibility1) {
          this.passwordVisibility1 = false;
          this.passwordType1 = "password";
          this.passwordImg1 = icons.whiteShopIcon.eyeSlash;
        } else {
          this.passwordVisibility1 = true;
          this.passwordType1 = "text";
          this.passwordImg1 = icons.whiteShopIcon.eye;
        }
        this.passwordOne.nativeElement.focus();
        break;
      case "confirmPassword":
        if (this.passwordVisibility2) {
          this.passwordVisibility2 = false;
          this.passwordType2 = "password";
          this.passwordImg2 = icons.whiteShopIcon.eyeSlash;
        } else {
          this.passwordVisibility2 = true;
          this.passwordType2 = "text";
          this.passwordImg2 = icons.whiteShopIcon.eye;
        }
        this.passwordTwo.nativeElement.focus();
        break;
    }
  }

  formSubmit() {
    // when user enter username and requests for OTP
    if (!this.isOtp && !this.isPassword) {
      if (this.isDataValid()) {
        this.submit("username");
      }
    }

    // After user enters OTP and confirms his identity as valid user to update password
    if (this.isOtp && !this.isPassword) {
      this.getOtp();
      if (this.otp || this.otpRegex.test(this.otp)) {
        this.submit("otp");
      }
    }

    // After OTP validates and user enter both password and confirm password
    if (this.isPassword) {
      if (
        this.password &&
        this.confirmPassword &&
        this.password.length > 7 &&
        this.password === this.confirmPassword
      ) {
        this.submit("password");
      }
    }
  }

  getEmailOrPhoneLabel(headers?) {
    return headers
      ? this.isEmailOrMobileConditional &&
        (this.isCustomerView || this.isWidget)
        ? this.isPhoneMandatory && !this.isEmailMandatory
          ? "Enter valid mobile number for OTP."
          : "Enter valid email for OTP."
        : "Enter valid mobile number/email for OTP."
      : this.isEmailOrMobileConditional &&
        (this.isCustomerView || this.isWidget)
      ? this.isPhoneMandatory && !this.isEmailMandatory
        ? "Enter Mobile number"
        : "Enter Email"
      : "Enter Email/Mobile Number";
  }

  validPassword() {
    return this.password && this.password.length > 7;
  }

  isMobileDevice() {
    return window.innerWidth <= 600;
  }
}

// Step 1 : Asks username to send the otp
// Step 2 : Input of OTP which is sent via mobile or email
// Step 3 : If OTP is correct, Asks for new password and resets the old password with new password
// Step 4 : Else Throws an error ,will not proceed further.
